import { scrollbarStyles } from "@ui/css/01.scrollbar/scrollbar.styles";
import { space } from "ui/src/design-tokens";

export const styles: { [x: string]: { [y: string]: any } } = {
    parentContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        bgColor: "white",
    },
    container: {
        display: "flex",
        flexWrap: "nowrap",
        ...scrollbarStyles,
        justifyContent: ["flex-start"],
        maxW: ["100%", "100%", "100%"],
        mr: [0, 0, 0],
        ml: [0, 0, 0],
        bgColor: "white",
        position: ["relative"],
        left: 0,
        /* We are using negative value to avoid cut the scroll area */
        pr: [4, 0],
        "::-webkit-scrollbar-track": {
            marginRight: [4, 4, 0],
        },
        gap: space["0.2"],
        paddingY: [4],
        overflow: ["scroll", "auto"],
        scrollbarHorizontal: "none",
    },
    bannerLink: {
        height: [12, "220px"],
        minW: ["fit-content", "128px"],
        textDecoration: "none",
        _hover: { textDecoration: "none", color: ["inherit", "inherit", "black"] },
    },
    bannerItemContainer: {
        height: "100%",
        bgColor: "white",
        w: ["fit-content", "128px"],
    },
    bannerImage: {
        bgColor: "white",
        h: "160px",
        w: "128px",
    },
    item: {
        bgColor: "white",
        gap: space["0.2"],
        flexWrap: "nowrap",
        width: "100%",
        height: [12, 40],
        display: "flex",
        overflow: "scroll",
        scrollbar: "none",
    },
    bannerText: {
        bgColor: ["gray.100", "white"],
        display: "flex",
        mt: [0, 2],
        textWrap: ["nowrap", "wrap"],
        width: "100%",
        fontWeight: "bold",
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        color: "black",
        paddingX: [3, 0],
        textTransform: "capitalize",
        "@media screen and (max-width: 480px)": {
            display: "flex",
            height: 10,
            textWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            paddingX: 3,
        },
    },
};
